// extracted by mini-css-extract-plugin
export var container = "LabelledCubeMap-module--container--72827";